import type { FC } from "react";
import { Alert, Box } from "@mui/material";

const isProduction = (): boolean => {
  const hostname = window.location.hostname;
  if (
    hostname.includes("localhost") ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("qa-app") ||
    hostname.includes("staging")
  ) {
    return false;
  }
  return true;
};

const isInternalUser = (username: string) => username.includes("qventus");

interface ProductionBannerProps {
  username: string;
}

const ProductionBanner: FC<ProductionBannerProps> = ({ username }) => {
  return isProduction() && isInternalUser(username) ? (
    <Box sx={{ position: "sticky", top: 0 }}>
      <Alert
        severity="error"
        sx={{
          borderRadius: 0,
          justifyContent: "center",
          py: 0.5,
        }}
      >
        <strong>PRODUCTION ENVIRONMENT</strong> — You are accessing live patient
        data
      </Alert>
    </Box>
  ) : null;
};

export default ProductionBanner;
